import { ReactNode } from "react";

import { ACCESS_TAB_LOAD_ERROR_STATUS } from "@/constants/access-request";
import { ACCESS_TAB_LOAD_ERROR_MESSAGE } from "@/constants/messages";

import { Load } from "components/load";
import PageError from "components/page-error";

interface AccessTabStateProps {
  isLoading: boolean;
  hasError: boolean;
  children: ReactNode;
}

export function AccessTabState({
  isLoading,
  hasError,
  children,
}: AccessTabStateProps): JSX.Element {
  if (isLoading) return <Load />;
  if (hasError) {
    return <PageError
        status={ACCESS_TAB_LOAD_ERROR_STATUS}
        message={ACCESS_TAB_LOAD_ERROR_MESSAGE}
      />;
  }

  return <>{children}</>;
}
